<mat-sidenav-container class="vh-100">
  <header>
    <div class="header-wrapper">
      <mat-toolbar class="mat-elevation-z1 p-absolute">
        <button *ngIf="hasInnerNav; else backButton" mat-icon-button (click)="innerNav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <ng-template #backButton>
          <button *ngIf="actions && actions[0]" mat-icon-button (click)="onClick(actions[0])">
            <mat-icon>arrow_back</mat-icon>
          </button>
        </ng-template>
        <ng-container *ngIf="isMultipleRow || userDetail">
          <span *ngIf="!title.text" class="title">{{ title }}</span>
          <span *ngIf="title.text" (click)="onClick(title)" class="title clickable">{{ title.text }}</span>
        </ng-container>

        <div class="spacer"></div>

        <button mat-icon-button class="fullscreen-toggle" (click)="toggleFullscreen()">
          <mat-icon *ngIf="!isFullscreen">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullscreen">fullscreen_exit</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="colors">
          <mat-icon class="gray-color">color_lens</mat-icon>
        </button>

        <mat-menu #colors="matMenu">
          <mat-grid-list cols="2" rowHeight="1:1">
            <ng-container *ngFor="let theme of themes">
              <mat-grid-tile>
                <input type="radio" [id]=theme name="color" [value]=theme (click)="onSubmit($event)">
                <label [for]=theme>
                  <span>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg" alt="Checked Icon" />
                  </span>
                </label>
              </mat-grid-tile>
            </ng-container>
          </mat-grid-list>
        </mat-menu>

        <ng-container *ngIf="slackUrl">
          <a href="{{ slackUrl }}" target="_blank">
            <div class="ml-1">
                <button mat-icon-button>
                  <mat-icon svgIcon="slack"></mat-icon>
                </button>
            </div>
          </a>
        </ng-container>

        <div class="ml-1">
          <button mat-icon-button [matMenuTriggerFor]="appMenu">
            <mat-icon>apps</mat-icon>
          </button>
          <mat-menu #appMenu="matMenu">
            <ng-container *ngIf="items">
              <button mat-menu-item *ngFor="let item of items" (click)="onClick(item)">{{ item.text }}</button>
            </ng-container>
          </mat-menu>
        </div>

        <app-auth-state class="ml-3"></app-auth-state>

      </mat-toolbar>
    </div>
  </header>

  <div class="w-100 content-wrapper">
    <mat-sidenav-container class="inner-nav-container">
      <mat-sidenav #innerNav mode="side" [opened]="hasInnerNav" class="mat-elevation-z4 pt-3">

        <ng-container *ngIf="userObservable | async; let user">
          <ng-container *ngIf="userDetail">
            <div class="text-center my-4">
              <img *ngIf="user.avatarUrl; let avatarUrl" class="img-circle"  [src]="avatarUrl" width="150" height="150" [alt]="avatarUrl">
              <h4 class="mt-4">{{ user.name }}</h4>
              <h6>{{ user.email }}</h6>
            </div>
          </ng-container>
        </ng-container>

        <mat-nav-list dense class="p-0">
          <ng-container *ngIf="actions && actions.length">
            <ng-container *ngFor="let action of actions">
              <mat-list-item (click)="onClick(action)"><mat-icon class="pt-1">arrow_back</mat-icon>{{ action.text }}</mat-list-item>
            </ng-container>
          </ng-container>

          <mat-divider></mat-divider>
          <!--Only Lecture Menu-->
          <ng-container *ngIf="subList; let list">
            <ng-container *ngIf="lectureTitle && subOnly">

              <!--Lecture Title bar in Only Lecture page-->
              <div class="lecture-lessons-title"
                   [ngClass]=AppConfig.theme>
                <h5 class="line-clamp-2">
                  <ng-container *ngIf="articleActions">
                    <ng-container *ngFor="let action of articleActions">
                      <ng-container *ngIf="lectureAction">
                        <span *ngIf="lectureTitle" (click)="onClick(lectureAction, $event)" class="title clickable color-white">
                          <mat-icon *ngIf="!lecturePublic" class="lock-icon">lock</mat-icon>
                          {{ lectureTitle }}
                        </span>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </h5>
              </div>

              <mat-list-item class="sub-item pl-1 lesson-list-item"  *ngFor="let item of list.items"
                             [ngClass]="(AppConfig.theme + ' ' + (isActivated(list, item) ? 'active' : ''))" (click)="onClick(item)">
                <span>{{ item[0] }}</span>
                <h5 class="line-clamp-2">
                  <mat-icon *ngIf="item.type; let type">{{ type }}</mat-icon>
                  <span class="list-dot color-gray font-weight-bold">·</span>
                  <span *ngIf="item.text; let text">{{ text }}</span>
                  <span *ngIf="item.observableText | async; let text">{{ text.$value }}</span>
                </h5>
              </mat-list-item>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!subOnly">
            <ng-container *ngIf="navList; let list">

              <!--Lecture List-->
              <ng-container *ngFor="let item of list.items">
                <ng-container>
                  <mat-list-item class="nav-item lecture-list-item pl-1" [ngClass]="(AppConfig.theme + ' ' + (isActivated(list, item) ? 'active' : ''))" (click)="onClick(item, $event)">
                    <h5 class="line-clamp-2">
                      <mat-icon *ngIf="!lecturePublic" class="lock-icon">lock</mat-icon>
                      <span *ngIf="item.text; let text">{{ text }}</span>
                      <span *ngIf="item.observableText | async; let text">{{ text.$value }}</span>
                    </h5>
                  </mat-list-item>
                </ng-container>
                <mat-divider></mat-divider>

                <ng-container *ngIf="isActivated(list, item)">
                  <ng-container *ngIf="subList; let list">
                    <!--Lesson List-->
                    <mat-list-item class="sub-item pl-1 lesson-list-item" *ngFor="let item of list.items" [ngClass]="(AppConfig.theme + ' ' + (isActivated(list, item) ? 'active' : ''))" (click)="onLessonClick(item, $event)">
                      <span>{{ item[0] }}</span>
                      <h5 class="line-clamp-2">
                        <mat-icon *ngIf="item.type; let type">{{ type }}</mat-icon>
                        <span class="list-dot">·</span>
                        <span *ngIf="item.text; let text">{{ text }}</span>
                        <span *ngIf="item.observableText | async; let text">{{ text.$value }}</span>
                      </h5>
                    </mat-list-item>
                  </ng-container>
                  <!--Lesson List-->
                  <mat-divider></mat-divider>
                </ng-container>
              </ng-container>
              <!--Lecture List-->

              <mat-divider></mat-divider>
            </ng-container>
          </ng-container>
        </mat-nav-list>
      </mat-sidenav>

      <nav class="page-navigation">
        <ng-container *ngIf="navActions && navActions[0]">
          <div class="nav-item px-2 top-0 bottom-0 p-absolute d-flex" align="left">
            <button mat-icon-button (click)="onClick(navActions[0])">
              <mat-icon class="color-gray">chevron_left</mat-icon>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="navActions && navActions[1]">
          <div class="nav-item px-2 top-0 bottom-0 p-absolute d-flex" align="right">
            <button mat-icon-button (click)="onClick(navActions[1])">
              <mat-icon class="color-gray">chevron_right</mat-icon>
            </button>
          </div>
        </ng-container>
      </nav>

      <ng-content></ng-content>
    </mat-sidenav-container>
  </div>
</mat-sidenav-container>




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/navbar/navbar.component.html